@if (selectedTasksArray?.length > 0) {
  <div
    class="checklist-floater-action-container modal-footter"
    [class]="fromBalanceRegister ? 'left-[60px]' : fromTransactionRegister ? 'absolute bottom-[24px] right-[300px]' : 'left-[250px]'"
    >
    <div class="checklist-floater-action-container-body">
      <div class="checklist-floater-item-container">
        <div class="checklist-floater-item-container-left">
          <h1 class="checklist-floater-item-container-left-title">{{ selectedTasksArray?.length }}</h1>
          <p class="checklist-floater-item-container-left-text">Selected</p>
        </div>
        @if (!fromBalanceRegister && !fromTransactionRegister) {
          <div
            class="checklist-floater-item-container-body"
            matRipple
            (click)="changeAssignee()"
            >
            <div class="d-flex">
              <div><span class="material-icons checklist-floater-item-container-body-icon">person</span></div>
              <div><span class="material-icons checklist-floater-item-container-body-arrow"> keyboard_arrow_down </span></div>
            </div>
            <p class="checklist-floater-item-container-body-text">Assignee</p>
          </div>
        }
        @if (!fromBalanceRegister && !fromTransactionRegister) {
          <div class="checklist-floater-item-container-body" matRipple>
            <div class="d-flex">
              <div>
                <span class="material-icons checklist-floater-item-container-body-icon" style="margin-left: -50px !important; margin-top: 5px !important"
                  >check_circle_outline</span
                  >
                </div>
                <div>
                  <mat-form-field appearance="fill" style="width: 1px !important">
                    <mat-select
                      name="frequency"
                      panelClass="miniCustomizePosition"
                      [disableOptionCentering]="true"
                      >
                      @for (stat of status; track stat) {
                        <mat-option [value]="stat.value" style="padding: 20px 80px 20px 20px">
                          <div [style]="{ height: '37px', width: 'fit-content', fontWeight: '700' }">
                            <p [style.color]="stat.color" (click)="changeStatus(stat.value)">
                              <span
                                [style.backgroundColor]="stat.backgroundColor"
                                [style]="{ height: '37px', padding: '6px 14px 6px 10px', borderRadius: '6px' }"
                                >
                                {{ stat.displayText }}
                              </span>
                            </p>
                          </div>
                        </mat-option>
                      }
                    </mat-select>
                    <span class="material-icons checklist-floater-item-container-body-arrow" style="margin-top: -25px !important">
                      keyboard_arrow_down
                    </span>
                  </mat-form-field>
                </div>
              </div>
              <p class="checklist-floater-item-container-body-text" style="margin-top: -32px !important">Status</p>
            </div>
          }
          @if (!fromBalanceRegister && !fromTransactionRegister) {
            <div
              class="checklist-floater-item-container-body"
              (click)="picker.open(); $event.stopPropagation()"
              >
              <span style="height: inherit; display: flex; flex-direction: column; align-items: center; justify-content: center; width: 100%">
                <div class="d-flex">
                  <div><i class="material-icons checklist-floater-item-container-body-icon">date_range</i></div>
                  <div><span class="material-icons checklist-floater-item-container-body-arrow"> keyboard_arrow_down </span></div>
                </div>
                <p class="checklist-floater-item-container-body-text">
                  <span class="flex-center" style="height: 0px">
                    <mat-form-field appearance="fill" class="checklist-duedate">
                      <input matInput [matDatepicker]="picker" [min]="todayDate" [formControl]="taskForm.get('dueDate')" (dateChange)="changeDueDate()" />
                      <mat-datepicker #picker [startAt]="todayDate"></mat-datepicker>
                    </mat-form-field>
                  </span>
                  Due Date
                </p>
              </span>
            </div>
          }
          @if (fromTransactionRegister) {
            <div class="checklist-floater-item-container-body" matRipple (click)="openCategoryDropdown($event)">
              <div class="block relative">
                <div class="absolute left-[40px]" [matTooltip]="disableCategoryButton ? 'You have selected a mix of income and expense transactions' : ''">
                  <span class="material-icons checklist-floater-item-container-body-icon" [style]="disableCategoryButton ? 'color:#C2C3C7;' : ''"
                    >category</span
                    >
                  </div>
                  <div>
                    <add-category
                      [showType]="true"
                      #expenseIncomeCategory
                      [fromFloaterMenu]="true"
                      [canCreateIncomeExpense]="false"
                      [transactionType]="transactionType"
                      [selectedCategories]="selectedCategories"
                      [disableCategoryButton]="disableCategoryButton"
                      (openEventEmitter)="onSelectOpened($event)"
                      (changeCategoryEventEmitter)="onCategorySelection($event)"
                    ></add-category>
                    <!-- <form [formGroup]="myForm" autocomplete="off">
                    <mat-form-field appearance="fill" style="width: 1px !important">
                      <mat-select
                        name="category"
                        panelClass="mediumCustomizePosition"
                        style="width: 250px !important"
                        [disableOptionCentering]="true"
                        (openedChange)="myInput.focus(); focusOutFunction()"
                        (selectionChange)="onCategorySelection($event.value)"
                        >
                        <div style="display: flex">
                          <input
                            class="myInput"
                            #myInput
                            matInput
                            id="input-category-search"
                            focused="'true'"
                            type="text"
                            style="padding-left: 5px !important"
                            (keyup)="search($event.target.value)"
                            autocomplete="off"
                            placeholder="Search for type"
                            />
                            <button mat-button mat-icon-button aria-label="Clear" class="mat-select-search-clear">
                              <mat-icon>search</mat-icon>
                            </button>
                          </div>
                          <mat-divider></mat-divider>
                          <div style="height: 250px">
                            <ng-container *ngFor="let currentData of selectedAreas">
                              <mat-option>
                                <div
                                  (click)="ShowChildOptionEstate($event, currentData); currentData.isOpen = !currentData.isOpen"
                                  style="display: flex; justify-content: space-between; align-items: center"
                                  >
                                  <span class="folder-title option-header">
                                    {{ currentData.name }}
                                  </span>
                                  <span class="material-icons subfolders__icon" style="font: bolder">
                                    {{ !currentData.isOpen ? 'keyboard_arrow_down' : 'keyboard_arrow_up' }}
                                  </span>
                                </div>
                              </mat-option>
                              <ng-container *ngIf="currentData.isOpen">
                                <mat-option
                                  [value]="ChildCurrentData?.id"
                                  (click)="SelectChildOptionEstate($event, currentData)"
                                  style="padding-left: 32px"
                                  *ngFor="let ChildCurrentData of currentData.banks"
                                  >
                                  {{ ChildCurrentData.name }}
                                </mat-option>
                              </ng-container>
                            </ng-container>
                          </div>
                        </mat-select>
                        <span class="material-icons checklist-floater-item-container-body-arrow" style="margin-top: -25px !important">
                          keyboard_arrow_down
                        </span>
                      </mat-form-field>
                    </form> -->
                  </div>
                </div>
                <p class="checklist-floater-item-container-body-text" [class]="isBrowserSafari? 'mt-0':'mt-5'" [style]="disableCategoryButton ? 'color:#C2C3C7;' : ''">Category</p>
              </div>
            }
            @if (fromTransactionRegister && !hideReviewButton) {
              <div
                class="checklist-floater-item-container-body"
                (click)="!disableReviewButton && changeReviewStatus()"
                >
                <span
                  class="material-icons checklist-floater-item-container-body-deleteicon"
                  [matTooltip]="disableReviewButton ? 'Transactions must be categorized before they can be marked as reviewed' : ''"
                  [style.color]="disableReviewButton == false ? (checkReviewStatus === 'reviewed' ? '#2ECF99' : '#25508e') : '#C2C3C7'"
                  >{{ checkReviewStatus === 'reviewed' ? 'check_circle' : 'check_circle_outline' }}</span
                  >
                  <p class="checklist-floater-item-container-body-text" [style.color]="disableReviewButton == false ? '#25508e' : '#C2C3C7'">Reviewed</p>
                </div>
              }
              @if (!hideDeleteButton) {
                <div
                  class="checklist-floater-item-container-body"
                  (click)="(!fromBalanceRegister ? (!disableDeleteButton ? true : false) : true) && deleteTasks()"
                  >
                  <span
                    class="material-icons checklist-floater-item-container-body-deleteicon"
                    [matTooltip]="fromTransactionRegister && disableDeleteButton ? 'Transactions imported through an API cannot be deleted' : ''"
                    [style.color]="fromTransactionRegister ? (disableDeleteButton == false ? '#EB5757 !important' : '#C2C3C7 !important') : '#EB5757'"
                    >delete</span
                    >
                    <p
                      class="checklist-floater-item-container-body-text"
                      style="margin-top: 0px !important"
                      [style.color]="fromTransactionRegister ? (disableDeleteButton == false ? '#EB5757' : '#C2C3C7') : '#EB5757'"
                      >
                      Delete
                    </p>
                  </div>
                }
                <div class="checklist-floater-item-container-right" (click)="clearSelection()">
                  <span class="checklist-floater-item-container-right-line"></span>
                  <span class="material-icons checklist-floater-item-container-right-closeicon">clear</span>
                  <p class="checklist-floater-item-container-right-closetext">Close</p>
                </div>
              </div>
            </div>
          </div>
        }
